// extracted by mini-css-extract-plugin
module.exports = {"vInkLighter":"#666","vInk":"#131313","title":"Step__title___tziS5","unfinished":"Step__unfinished___uE8mB","current":"Step__current___rfoQN","finished":"Step__finished___9xm9J"};